import { Link, useLocation } from "react-router-dom";
import { Home, Search, Heart, MessageSquare, User } from "lucide-react";
import { useApp } from "../../context/AppContext";

const ITEMS = [
  { label: "Home", to: "/", icon: Home, id: "home" },
  { label: "Search", to: "/properties", icon: Search, id: "search" },
  { label: "Saved", to: "/saved", icon: Heart, id: "saved" },
  { label: "Enquiries", to: "/dashboard", icon: MessageSquare, id: "enquiries" },
  { label: "Profile", to: "/dashboard", icon: User, id: "profile" },
];

export function MobileNav() {
  const { pathname } = useLocation();
  const { saved } = useApp();
  return (
    <nav data-testid="mobile-bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-pbs-line shadow-[0_-4px_20px_rgba(35,107,69,0.08)]">
      <div className="grid grid-cols-5">
        {ITEMS.map((it) => {
          const active = pathname === it.to;
          const Icon = it.icon;
          return (
            <Link key={it.id} to={it.to} data-testid={`mobile-nav-${it.id}`}
              className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-semibold relative ${active ? "text-pbs-purple" : "text-pbs-grey"}`}>
              <span className="relative">
                <Icon size={20} strokeWidth={active ? 2.5 : 2} />
                {it.id === "saved" && saved.length > 0 && (
                  <span className="absolute -top-1.5 -right-2 bg-pbs-coral text-white text-[9px] font-bold w-3.5 h-3.5 rounded-full flex items-center justify-center">{saved.length}</span>
                )}
              </span>
              {it.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileNav;
